/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Tool_Invite_MemberInputs */



/**
* | output |
* | --- |
* | "Inviting member" |
*
* @param {Uno_Tool_Invite_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_tool_invite_member = /** @type {((inputs?: Uno_Tool_Invite_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Tool_Invite_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lade Mitglied ein")
	return /** @type {LocalizedString} */ ("Inviting member")
});